module.exports = __webpack_public_path__ + "static/media/S2.288c6c4d.png";